import script from "./DropMenuUser.vue?vue&type=script&setup=true&lang=js"
export * from "./DropMenuUser.vue?vue&type=script&setup=true&lang=js"

import "./DropMenuUser.vue?vue&type=style&index=0&id=09e02ed5&lang=scss"

const __exports__ = script;

export default __exports__